/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "../../../Common/Style/summaryStyle";
import GridEditRow from "../../../Common/GridEditRow/GridEditRow";
import Typography from "@mui/material/Typography";
import { AbstractCase } from "../../../../../types/Entities/AbstractCase";
import { Box } from "@mui/material";

type ContactDataProps = {
  formData: AbstractCase  | Record<string, any>;
  basePath: string;
};
const ContactData = ({ formData, basePath }: ContactDataProps) => {
  const formPath = basePath + "/kontaktdaten";
  const section = "contactData";
  const personType = "alimonyPartner";
  return (
    <>
      <Grid item xs={12} sx={summaryStyle.subHeadline}>
        <Typography variant={"h5"}>Persönliche Angaben</Typography>
      </Grid>
      <Grid item xs={12} sx={summaryStyle.question}>
        <Box id={personType + ".person.gender"} sx={summaryStyle.scrollToAnchor} />
        Anrede
      </Grid>
      <GridEditRow
        item
        xs={12}
        to={{
          pathname: formPath,
          state: {
            section: section,
            field: personType + ".person.gender",
          },
        }}
      >
        {formData.alimonyPetitioner.person.gender === "male" ? "Herr" : "Frau"}
      </GridEditRow>

      <Grid item xs={12} sx={summaryStyle.question}>
        <Box id={personType + ".person.givenName"} sx={summaryStyle.scrollToAnchor} />
        Vorname
      </Grid>
      <GridEditRow
        item
        xs={12}
        to={{
          pathname: formPath,
          state: {
            section: section,
            field: personType + ".person.givenName",
          },
        }}
      >
        {formData.alimonyPetitioner.person.givenName}
      </GridEditRow>

      <Grid item xs={12} sx={summaryStyle.question}>
        <Box id={personType + ".person.familyName"} sx={summaryStyle.scrollToAnchor} />
        Nachname
      </Grid>
      <GridEditRow
        item
        xs={12}
        to={{
          pathname: formPath,
          state: {
            section: section,
            field: personType + ".person.familyName",
          },
        }}
      >
        {formData.alimonyPetitioner.person.familyName}
      </GridEditRow>
      <Grid item xs={12} sx={summaryStyle.question}>
        <Box id={"telephone"} sx={summaryStyle.scrollToAnchor} />
        Telefonnummer
      </Grid>
      <GridEditRow
        item
        xs={12}
        to={{
          pathname: formPath,
          state: {
            section: section,
            field: "telephone",
          },
        }}
      >
        {formData.customer.telephone}
      </GridEditRow>
      <Grid item xs={12} sx={summaryStyle.question}>
        <Box id={"insurancePolicyNumber"} sx={summaryStyle.scrollToAnchor} />
        Versichertennummer
      </Grid>
      <GridEditRow
        item
        xs={12}
        to={{
          pathname: formPath,
          state: {
            section: section,
            field: "insurancePolicyNumber",
          },
        }}
      >
        {formData.insurance.insurancePolicyNumber}
      </GridEditRow>
      <Grid item xs={12} sx={summaryStyle.question}>
        <Box id={"caseReferenceNumber"} sx={summaryStyle.scrollToAnchor} />
        Schadennummer
      </Grid>
      <GridEditRow
        item
        xs={12}
        to={{
          pathname: formPath,
          state: {
            section: section,
            field: "caseReferenceNumber",
          },
        }}
      >
        {formData.insurance.caseReferenceNumber}
      </GridEditRow>
    </>
  );
};

export default ContactData;
